import { render, staticRenderFns } from "./account-add.vue?vue&type=template&id=0daab07e&scoped=true"
import script from "./account-add.vue?vue&type=script&lang=js"
export * from "./account-add.vue?vue&type=script&lang=js"
import style0 from "./account-add.vue?vue&type=style&index=0&id=0daab07e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daab07e",
  null
  
)

export default component.exports